import { ref, type Ref } from 'vue'

export interface ToastItem {
    id: number
    severity: 'success' | 'info' | 'warn' | 'error'
    summary?: string
    detail?: string
    life?: number
}

const toasts: Ref<ToastItem[]> = ref([])
let nextId = 1

export function useToast() {
    function show(item: Omit<ToastItem, 'id'>) {
        const id = nextId++
        const full: ToastItem = { id, life: 4000, ...item }
        toasts.value.push(full)
        if (full.life && full.life > 0) {
            window.setTimeout(() => remove(id), full.life)
        }
        return id
    }

    function remove(id: number) {
        const idx = toasts.value.findIndex(t => t.id === id)
        if (idx >= 0) toasts.value.splice(idx, 1)
    }

    return {
        toasts,
        show,
        remove,
        success: (summary: string, detail?: string) => show({ severity: 'success', summary, detail }),
        info: (summary: string, detail?: string) => show({ severity: 'info', summary, detail }),
        warn: (summary: string, detail?: string) => show({ severity: 'warn', summary, detail }),
        error: (summary: string, detail?: string) => show({ severity: 'error', summary, detail, life: 6000 })
    }
}
